export default {
  data(){
    return {
      page: {
        num: 1,
        size: 20,
        total: 0
      },
    }
  },
  methods: {
    handleSizeChange(size) {
      this.page.num = 1;
      this.page.size = size;
      this.getList();
    },
    handleCurrentChange(page) {
      this.page.num = page;
      this.getList();
    },

    // 计算高度
    listenTableHeight(num1= 10,num2= 10){

      // 监听窗口大小变化，调整table高度
      window.onresize = () => {
        return (() => {
          this.countTableHeight(num1)
        })()

      };

      this.countTableHeight(num2);
    },
    countTableHeight(number= 10){
      let t= setTimeout(()=>{
        if (document.body.clientHeight <= 550) {
          this.tableHeight = null
        } else {
          this.tableHeight = this.calcHeight(number);
        }
        clearTimeout(t);
      },200);
    },
    calcHeight(number= 10) {
      const tableOffsetTop = document.querySelector(".table-list-mod").offsetTop;
      const paginationHeight = document.querySelector(".table-pagination").offsetHeight+ number;

      return document.getElementById("app").offsetHeight - tableOffsetTop - paginationHeight;
    }
  }
}
